export type ContactNameFields = {
  first_name?: string;
  last_name?: string;
  friendly_name?: string;
};

export function contactLegalName(contact: ContactNameFields): string {
  return [contact.first_name, contact.last_name]
    .filter(namePart => namePart)
    .join(' ');
}

/** Nominal-facing labels: friendly name when set, otherwise legal name. */
export function contactFriendlyLabel(contact: ContactNameFields): string {
  const friendly = contact.friendly_name?.trim();
  if (friendly) {
    return friendly;
  }
  return contactLegalName(contact);
}
